import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Input, Row, Col } from "../../../ui/ot";
import { useLocation } from "react-router-dom";
import BackStagePatrons from './../../views/BackStage/SearchPatrons'
import { useBorrower } from "../../controllers/BorrowerController";

// Test Data
const mockSearchResults = [
    {
        name: "API_KEY",
        card: "KEY001",
        dob: "1990-01-01",
        category: "測試用群組",
        library: "介壽校區",
        address: "Address 1",
        phone: "123-456-7890",
    },
    {
        name: "Camel",
        card: "KEY002",
        dob: "2002-03-30",
        category: "測試用群組",
        library: "巨輪校區",
        address: "高雄市",
        phone: "097-037-7517",
    },
    {
        name: "FkDogg",
        card: "KEY003",
        dob: "2002-03-31",
        category: "測試用群組",
        library: "和平校區",
        address: "台南市",
        phone: "091-234-5123",
    },
];

const CirculationReserve = ({

}) => {
    const searchTimeoutRef = useRef(setTimeout(() => { }))
    const [searchTerm, setSearchTerm] = useState("");
    const [suggestions, setSuggestions] = useState([mockSearchResults]);
    const [results, setResults] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const { biblionumber } = useParams()

    useEffect(() => {
        clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(() => {
            getBorrowerData({
                cardnumber: searchTerm
            })
        }, 100);
    }, [searchTerm]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value)
    };
    //傳送title跟點擊連結
    const handleSuggestionClick = (suggestion) => {
        navigate(`../CirculationPlace/${suggestion?.borrowernumber}`, { state: { BorrowerData: [{ ...suggestion }], biblionumber: biblionumber } });
    };

    const handleSearchClick = () => {
        setResults(BorrowerData);
        setSuggestions([]);
    };

    const {
        BorrowerData,
        getBorrowerData
    } = useBorrower({
        onBefore: () => { },
        onFinish: () => { },
    })
    return (
        <MainContainer>
            <SearchContainer>
                <h2>Search patrons</h2>
                <SearchBox>
                    <Label htmlFor="search-input">
                        Enter patron card number or partial name:
                    </Label>
                    <Row gutter={[8, 8]}>
                        <Col>
                            <Input
                                id="search-input"
                                type="text"
                                value={searchTerm}
                                onChange={handleSearchChange}
                            />
                        </Col>
                        <Col>
                            <Button onClick={handleSearchClick}>Search</Button>
                        </Col>
                    </Row>
                    {BorrowerData.length > 0 && (
                        <SuggestionsBox>
                            {BorrowerData.map((suggestion, index) => (
                                <SuggestionItem
                                    key={index}
                                    onClick={() => handleSuggestionClick(suggestion)}
                                >
                                    {suggestion?.surname}, ({suggestion?.cardnumber}){" "}
                                    <Highlight>{suggestion?.branchname}</Highlight>
                                </SuggestionItem>
                            ))}
                        </SuggestionsBox>
                    )}
                </SearchBox>
                <BrowseBox>
                    <p>Browse by last name:</p>
                    <AlphabetLinks>
                        {"ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((letter) => (
                            <a key={letter} href={`#${letter}`}>
                                {letter}
                            </a>
                        ))}
                    </AlphabetLinks>
                </BrowseBox>
            </SearchContainer>
            <WhiteBox>
                {results.length > 0 && (
                    <Table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Card</th>
                                <th>Date of birth</th>
                                <th>Category</th>
                                <th>Library</th>
                                <th>Address</th>
                                <th>Phone</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.map((result, index) => (
                                <tr key={index} onClick={() => handleSuggestionClick(result)}>
                                    <td>{result.name}</td>
                                    <td>{result.card}</td>
                                    <td>{result.dob}</td>
                                    <td>{result.category}</td>
                                    <td>{result.library}</td>
                                    <td>{result.address}</td>
                                    <td>{result.phone}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </WhiteBox>
        </MainContainer>
    );
};

const MainContainer = styled.div`
  font-family: Arial, sans-serif;
  text-align: left;
  padding: 20px;
`;

const SearchContainer = styled.div`
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 4px;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const SearchBox = styled.div`
  margin-bottom: 20px;
  position: relative;

  @media (max-width: 768px) {
    margin-bottom: 10px;
  }
`;

const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: bold;

  @media (max-width: 768px) {
    margin-bottom: 5px;
  }
`;

const BrowseBox = styled.div`
  p {
    margin-bottom: 8px;
    font-weight: bold;

    @media (max-width: 768px) {
      margin-bottom: 5px;
    }
  }
`;

const AlphabetLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  a {
    margin: 4px;
    color: green;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }

    @media (max-width: 768px) {
      margin: 2px;
    }
  }
`;

const SuggestionsBox = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  border: 1px solid #ddd;
  border-top: none;
  position: absolute;
  width: calc(100% - 100px);
  max-height: 150px;
  overflow-y: auto;
  background-color: #fff;
  z-index: 1;

  @media (max-width: 768px) {
    width: calc(100% - 40px);
  }
`;

const SuggestionItem = styled.li`
  padding: 8px;
  cursor: pointer;
  &:hover {
    background-color: #f2f2f2;
  }

  @media (max-width: 768px) {
    padding: 5px;
  }
`;

const Highlight = styled.span`
  background-color: #d4edda;
  border-radius: 3px;
  padding: 0 4px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
  th {
    background-color: #f2f2f2;
    font-weight: bold;
  }

  @media (max-width: 768px) {
    th,
    td {
      padding: 4px;
    }
  }
`;

const WhiteBox = styled.div`
  background-color: #fff;
  padding: 1em;
  width: -webkit-fill-available;

  @media (max-width: 768px) {
    padding: 0.5em;
  }
`;

export default CirculationReserve;
